import { Loading as VoidLoading } from "@void-orbit/ui";

export type Opacity = "full" | "middle" | "none";

export interface LoadingProps {
  opacity?: Opacity;
};

export const Loading = ({ opacity = "middle" }: LoadingProps ) => (
  <VoidLoading opacity={ opacity } product="chat" label="Carregando aplicação" />
);
